var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconClose = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.53035 5.46967C6.23746 5.17678 5.76258 5.17678 5.46969 5.46967C5.1768 5.76256 5.1768 6.23744 5.46969 6.53033L10.9394 12L5.46967 17.4697C5.17678 17.7626 5.17678 18.2375 5.46967 18.5303C5.76256 18.8232 6.23744 18.8232 6.53033 18.5303L12 13.0607L17.4697 18.5303C17.7626 18.8232 18.2375 18.8232 18.5303 18.5303C18.8232 18.2374 18.8232 17.7626 18.5303 17.4697L13.0607 12L18.5303 6.53035C18.8232 6.23746 18.8232 5.76258 18.5303 5.46969C18.2374 5.1768 17.7626 5.1768 17.4697 5.46969L12 10.9393L6.53035 5.46967Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconClose);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon--close.29293ea4dd628eb970a081eb5d6d1da9.svg";